export const stepperMaxStepShow = 6;
export const cities = [ 'Paris', 'Lyon', 'Bordeaux', 'Toulouse', 'Marseille', 'Nantes' ];
export const defaultPostalCodeCities = [ '75000', '69000', '33300', '31000', '13000', '44000' ];
export const capacityChoices = [
  {
    key: 'guided_search.capacity.tag',
    value: {
      min: 1,
      max: 4,
    },
    active: false,
  },
  {
    key: 'guided_search.capacity.tag',
    value: {
      min: 5,
      max: 9,
    },
    active: false,
  },
  {
    key: 'guided_search.capacity.tag',
    value: {
      min: 10,
      max: 19,
    },
    active: false,
  },
  {
    key: 'guided_search.capacity.tag',
    value: {
      min: 20,
      max: 49,
    },
    active: false,
  },
  {
    key: 'guided_search.capacity.tag',
    value: {
      min: 50,
      max: 99,
    },
    active: false,
  },
  {
    key: 'guided_search.capacity.100+',
    value: {
      min: 100,
      max: null,
    },
    active: false,
  },
];
export const durationChoices = [
  {
    key: 'guided_search.duration.tag',
    value: 3,
  },
  {
    key: 'guided_search.duration.tag',
    value: 6,
  },
  {
    key: 'guided_search.duration.tag',
    value: 12,
  },
  {
    key: 'guided_search.duration.24+',
    value: 24,
  },
  {
    key: 'guided_search.duration.unknown',
    value: -1,
  },
];
